import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import signin from "../assets/img/others/signup.png";
import logo from "../assets/img/logo/bfc-logo-removebg-preview.png";
import { GiArchiveRegister } from "react-icons/gi";
import { UserContext } from "../context/User";
import { CartContext } from "../context/CartContext";

import { isName, isEmail, isMobileNo } from "../utils/validations";
import axios from "axios";

const Signup = () => {
  // Form states
  
  const [name, setName] = useState("");
   const [login_type, setlogin_type] = useState("");
  const [email, setEmail] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [termCon, setTermCon] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Error states
  const [errorName, setErrorName] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorMobileno, setErrorMobileno] = useState("");
  const [checkBoxError, setCheckBoxError] = useState("");
  const [errorOtp, setErrorOtp] = useState("");

  // Contexts and navigation
  const { signUp } = useContext(UserContext);
  const { fetchExistingCart } = useContext(CartContext);
  const navigate = useNavigate();

  // Validate form inputs
  const checkValidation = () => {
    let hasError = false;

    if (name === "") {
      setErrorName("Mandatory Name");
      hasError = true;
    } else if (!isName(name)) {
      setErrorName("Invalid Name");
      hasError = true;
    } else {
      setErrorName("");
    }

    if (email === "") {
      setErrorEmail("Mandatory Email");
      hasError = true;
    } else if (!isEmail(email)) {
      setErrorEmail("Invalid Email");
      hasError = true;
    } else {
      setErrorEmail("");
    }

    if (mobileno === "") {
      setErrorMobileno("Mandatory Mobile Number");
      hasError = true;
    } else if (!isMobileNo(mobileno)) {
      setErrorMobileno("Invalid Mobile Number");
      hasError = true;
    } else {
      setErrorMobileno("");
    }

    if (!termCon) {
      setCheckBoxError("You must agree to the terms");
      hasError = true;
    } else {
      setCheckBoxError("");
    }

    return hasError;
  };

  // Send OTP and handle response
  const sendOtp = async (e) => {
    e.preventDefault();
    if (checkValidation()) return;

    setIsLoading(true);
    setErrorEmail("");
    setErrorMobileno("");
    setErrorOtp("");

    try {
      const response = await axios.post("https://admin.bookstore.bfcpublications.com/api/mobile_register", {
        name,
        email,
        mobile: mobileno,
      });

      // Success case: Navigate to OTP page without alert
      //console.log(response.data.user_id)
      if (response.data.user_id) {
        navigate("/otp", {
          state: { name, email, mobile: mobileno,login_type:'register' },
        });
      } else {
        // Handle server-side validation errors
        if (response.data.errors) {
          if (response.data.errors.email) {
            setErrorEmail("This email is already registered.");
          }
          if (response.data.errors.mobile) {
            setErrorMobileno("This mobile number is already registered.");
          }
        } else {
          setErrorOtp(response.data.message || "Failed to send OTP. Please try again.");
        }
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        // Handle 400 error with specific error messages
        if (error.response.data.errors.email) {
          setErrorEmail("This email is already registered.");
        }
        if (error.response.data.errors.mobile) {
          setErrorMobileno("This mobile number is already registered.");
        }
      } else {
        setErrorOtp("Error sending OTP. Check your network or contact support.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="login-bg pt-3">
      <div className="container">
        <div className="brand-logo">
          <a href="/">
            <img src={logo} alt="BFC Logo" className="img-fluid" />
          </a>
        </div>
        <div className="row align-items-stretch pt-2">
          <div className="col-md-7 d-md-block d-none">
            <img src={signin} alt="Signup Illustration" className="img-fluid" />
          </div>
          <div className="col-md-5 align-self-center">
            <div className="shadow p-4 rounded-lg bg-white">
              <h4 className="pb-2 pt-1 text_color font-bold text-2xl">Take Your First Step</h4>
              <form onSubmit={sendOtp}>
                <div className="form-group mb-3">
                  <input
                    className={`search-input si w-full p-2 border rounded ${errorName ? "border-red-500" : "border-gray-300"}`}
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    name="name"
                    placeholder="Enter Your Full Name"
                  />
                  {errorName && <span className="text-red-500 text-sm text-danger">{errorName}</span>}
                </div>
                <div className="form-group mb-3">
                  <input
                    className={`search-input si w-full p-2 border rounded ${errorEmail ? "border-red-500" : "border-gray-300"}`}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    placeholder="Enter Your Email"
                  />
                  {errorEmail && <span className="text-red-500 text-sm text-danger">{errorEmail}</span>}
                </div>
                <div className="form-group mb-3">
                  <input
                    className={`search-input si w-full p-2 border rounded ${errorMobileno ? "border-red-500" : "border-gray-300"}`}
                    type="text"
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                    name="mobileno"
                    placeholder="Mobile Number"
                  />
                  {errorMobileno && <span className="text-red-500 text-sm text-danger">{errorMobileno}</span>}
                </div>
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={termCon}
                    onChange={(e) => setTermCon(e.target.checked)}
                    id="terms"
                  />
                  <label className="form-check-label login-first-step-para text-sm" htmlFor="terms">
                    I hereby accord my consent to process my above mentioned personal data by BFC Publications Pvt. Ltd. for the purpose of Author support/Service Promotion, in accordance with the provisions of DPDP Act 2023.{" "}
                    <a href="https://bfcpublications.com/DPDP_Act" target="_blank" className="text_color underline">
                      Click here to know more
                    </a>
                  </label>
                  {checkBoxError && <span className="text-red-500 text-sm block text-danger">{checkBoxError}</span>}
                </div>
                {errorOtp && (
                  <div className="form-group mb-3">
                    <span className="text-red-500 text-sm text-danger">{errorOtp}</span>
                  </div>
                )}
                <div className="form-group mt-4">
                  <button
                    type="submit"
                    className={`fw-bold border-0 text-white login-btn rounded-pill bg_color w-100 py-2 flex items-center justify-center ${
                      isLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Send OTP"}
                    <GiArchiveRegister className="ms-2 fs-5" />
                  </button>
                </div>
                <hr className="my-4" />
                <p className="fs-14 text-rale text-center">
                  Already have an account?{" "}
                  <Link to="/signin" className="login-a text_color font-bold">
                    Sign-In
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;